"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingRewardsMultiGauge__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_stakingToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rewards_distributor_address",
                type: "address",
            },
            {
                internalType: "string[]",
                name: "_rewardSymbols",
                type: "string[]",
            },
            {
                internalType: "address[]",
                name: "_rewardTokens",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "_rewardManagers",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "_rewardRatesManual",
                type: "uint256[]",
            },
            {
                internalType: "address[]",
                name: "_gaugeControllers",
                type: "address[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "rewardRates",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "rewardsDuration",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "num_periods_elapsed",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
        ],
        name: "NoEnoughReward",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "multiplier",
                type: "uint256",
            },
        ],
        name: "LockedStakeMaxMultiplierUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "secs",
                type: "uint256",
            },
        ],
        name: "LockedStakeMinTime",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "secs",
                type: "uint256",
            },
        ],
        name: "LockedStakeTimeForMaxMultiplier",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "multiplier",
                type: "uint256",
            },
        ],
        name: "MaxVeSumerMultiplier",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "destination_address",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Recovered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reward",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "token_address",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "destination_address",
                type: "address",
            },
        ],
        name: "RewardPaid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "newDuration",
                type: "uint256",
            },
        ],
        name: "RewardsDurationUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "RewardsPeriodRenewed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "secs",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "kek_id",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "source_address",
                type: "address",
            },
        ],
        name: "StakeLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "kek_id",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "destination_address",
                type: "address",
            },
        ],
        name: "WithdrawLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "scale_factor",
                type: "uint256",
            },
        ],
        name: "veSumerPerUsdForMaxBoostUpdated",
        type: "event",
    },
    {
        inputs: [],
        name: "MULTIPLIER_PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "migrator_address",
                type: "address",
            },
        ],
        name: "addMigrator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "calcCurCombinedWeight",
        outputs: [
            {
                internalType: "uint256",
                name: "old_combined_weight",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "new_veSumer_multiplier",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "new_combined_weight",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "reward_token_address",
                type: "address",
            },
            {
                internalType: "address",
                name: "new_manager_address",
                type: "address",
            },
        ],
        name: "changeTokenManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "combinedWeightOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "earned",
        outputs: [
            {
                internalType: "uint256[]",
                name: "new_earned",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "gaugeControllers",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAllRewardTokens",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getReward",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getRewardForDuration",
        outputs: [
            {
                internalType: "uint256[]",
                name: "rewards_per_duration_arr",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getRewardSymbols",
        outputs: [
            {
                internalType: "string[]",
                name: "",
                type: "string[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "greylist",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_address",
                type: "address",
            },
        ],
        name: "greylistAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "caller_addr",
                type: "address",
            },
            {
                internalType: "address",
                name: "reward_token_addr",
                type: "address",
            },
        ],
        name: "isTokenManagerFor",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastUpdateTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "secs",
                type: "uint256",
            },
        ],
        name: "lockMultiplier",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lock_max_multiplier",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lock_time_for_max_multiplier",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lock_time_min",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "lockedLiquidityOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "lockedStakesOf",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "kek_id",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "start_timestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "liquidity",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "ending_timestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "lock_multiplier",
                        type: "uint256",
                    },
                ],
                internalType: "struct StakingRewardsMultiGauge.LockedStake[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "migrationsOn",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker_address",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "secs",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "start_timestamp",
                type: "uint256",
            },
        ],
        name: "migrator_stakeLocked_for",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker_address",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "kek_id",
                type: "bytes32",
            },
        ],
        name: "migrator_withdraw_locked",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "minVeSumerForMaxBoost",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "periodFinish",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenAmount",
                type: "uint256",
            },
        ],
        name: "recoverERC20",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "migrator_address",
                type: "address",
            },
        ],
        name: "removeMigrator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "rewardManagers",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "token_idx",
                type: "uint256",
            },
        ],
        name: "rewardRates",
        outputs: [
            {
                internalType: "uint256",
                name: "rwd_rate",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "rewardRatesManual",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "rewardSymbols",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "rewardTokenAddrToIdx",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "rewardTokens",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardsCollectionPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardsDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardsPerToken",
        outputs: [
            {
                internalType: "uint256[]",
                name: "newRewardsPerTokenStored",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewards_distributor",
        outputs: [
            {
                internalType: "contract IFraxGaugeFXSRewardsDistributor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "reward_token_address",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rewards_distributor_address",
                type: "address",
            },
            {
                internalType: "address",
                name: "_gauge_controller_address",
                type: "address",
            },
            {
                internalType: "bool",
                name: "sync_too",
                type: "bool",
            },
        ],
        name: "setGaugeController",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_lock_time_for_max_multiplier",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_lock_time_min",
                type: "uint256",
            },
        ],
        name: "setLockedStakeTimeForMinAndMaxMultiplier",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_lock_max_multiplier",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_veSumer_max_multiplier",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_veSumer_per_usd_for_max_boost",
                type: "uint256",
            },
        ],
        name: "setMultipliers",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "reward_token_address",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "new_rate",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "sync_too",
                type: "bool",
            },
        ],
        name: "setRewardRate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_rewardsDuration",
                type: "uint256",
            },
        ],
        name: "setRewardsDuration",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "liquidity",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "secs",
                type: "uint256",
            },
        ],
        name: "stakeLocked",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "migrator_address",
                type: "address",
            },
        ],
        name: "stakerAllowMigrator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "migrator_address",
                type: "address",
            },
        ],
        name: "stakerDisallowMigrator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "staker_allowed_migrators",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stakesUnlocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stakingPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stakingToken",
        outputs: [
            {
                internalType: "contract IUniswapV2Pair",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "sync",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "force_update",
                type: "bool",
            },
        ],
        name: "sync_gauge_weights",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleMigrations",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleRewardsCollection",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleStaking",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleWithdrawals",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "totalCombinedWeight",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalLiquidityLocked",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unlockStakes",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "usdPerLPToken",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "usd_address",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "userStakedUsd",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "valid_migrators",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "veSumerMultiplier",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "veSumer_max_multiplier",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "veSumer_per_usd_for_max_boost",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "kek_id",
                type: "bytes32",
            },
        ],
        name: "withdrawLocked",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "withdrawalsPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class StakingRewardsMultiGauge__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_stakingToken, _rewards_distributor_address, _rewardSymbols, _rewardTokens, _rewardManagers, _rewardRatesManual, _gaugeControllers, overrides) {
        return super.getDeployTransaction(_stakingToken, _rewards_distributor_address, _rewardSymbols, _rewardTokens, _rewardManagers, _rewardRatesManual, _gaugeControllers, overrides || {});
    }
    deploy(_stakingToken, _rewards_distributor_address, _rewardSymbols, _rewardTokens, _rewardManagers, _rewardRatesManual, _gaugeControllers, overrides) {
        return super.deploy(_stakingToken, _rewards_distributor_address, _rewardSymbols, _rewardTokens, _rewardManagers, _rewardRatesManual, _gaugeControllers, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.StakingRewardsMultiGauge__factory = StakingRewardsMultiGauge__factory;
StakingRewardsMultiGauge__factory.bytecode = _bytecode;
StakingRewardsMultiGauge__factory.abi = _abi;
//# sourceMappingURL=StakingRewardsMultiGauge__factory.js.map